import { useLayoutEffect, useRef, useState } from "react";
import { prefersReducedMotion } from "./motion";

// When the word changes it rolls like a slot machine reel: the old word rolls
// up and out as the new one rolls in. At rest it is plain text.
export default function SlotWord({ word }) {
  const [prev, setPrev] = useState(word);
  const [spin, setSpin] = useState(null);
  const windowRef = useRef(null);

  if (word !== prev) {
    setPrev(word);
    setSpin(
      prefersReducedMotion() ? null : { from: prev, to: word, id: Date.now() },
    );
  }

  // The two words differ in width: slide from one to the other during the
  // roll, so whatever follows glides over instead of jumping.
  useLayoutEffect(() => {
    const el = windowRef.current;
    if (!spin || !el) return;
    const [from, to] = [...el.querySelectorAll(".slot__item")].map(
      (item) => item.getBoundingClientRect().width,
    );
    if (!from || !to) return;
    el.style.transition = "none";
    el.style.width = `${from}px`;
    el.getBoundingClientRect();
    el.style.transition = "";
    el.style.width = `${to}px`;
  }, [spin?.id]);

  if (!spin) return word;

  return (
    <span ref={windowRef} className="slot" aria-label={spin.to}>
      <span className="slot__sizer" aria-hidden="true">
        {spin.to}
      </span>
      <span
        key={spin.id}
        className="slot__reel"
        aria-hidden="true"
        onAnimationEnd={() => setSpin(null)}
      >
        <span className="slot__item">{spin.from}</span>
        <span className="slot__item">{spin.to}</span>
      </span>
    </span>
  );
}
